<template>
  <div>
    <el-row class="tac">
      <el-col>
        <!-- <div  class="menuTitleStyle"><h5>菜单</h5></div> -->

        <el-menu :default-active="$route.path" active-text-color="#FF0000" :collapse="false"
          class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :default-openeds="openeds" router>
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>基本操作</span>
            </template>

            <el-tooltip class="item" effect="dark" content="管理我的打分表" placement="right">
              <el-menu-item index="/form_list"><span slot="title">管理打分表</span></el-menu-item>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" content="制作打分表入口" placement="right">
              <el-menu-item index="/make_form_list"> <span slot="title">制作打分表</span></el-menu-item>
            </el-tooltip>



            <el-tooltip class="item" effect="dark" content="管理打分人或被打分人名单" placement="right">
              <el-menu-item index="/prepared_user_list"><span slot="title">预存名单</span></el-menu-item>
            </el-tooltip>


          </el-submenu>


        </el-menu>
      </el-col>

    </el-row>
    <el-row>
      <el-divider></el-divider>
    </el-row>

  </div>

</template>

<script>
  export default {
    name: 'MenuList',
    data: function() {
      return {
        openeds: ['1', '2', '3', '4', '5'],
        username: '',
        activeIndex: '',

        invited_count: 0,
        myform_count: 0
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.setCurrentRoute()
      this.loadMenuNum()
    },
    // 检测路由变化
    watch: {
      $route() {
        this.setCurrentRoute()
      }
    },
    methods: {
      setCurrentRoute() {
        this.activeIndex = this.$route.path // 通过他就可以监听到当前路由状态并激活当前菜单
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath)
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath)
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath)

        //
        if (key === '1-0') {
          this.active_key = '1-0'
          this.$router.push('/table_view')
        } else if (key === '1-1') {
          this.active_key = '1-1'
          this.$router.push('/make_form')
        } else if (key === '1-3') {
          this.active_key = '1-3'
          this.$router.push('/form_list')
        } else if (key === '1-2') {
          this.active_key = '1-2'
          this.$router.push('/import_excel')
        } else if (key === '1-4') {
          this.active_key = '1-4'
          this.$router.push('/read_me')
        }
      },
      helpShow() {
        console.log('用户名' + this.username)
        if (this.username === 'admin') {
          return true
        } else {
          return false
        }
      },
      loadMenuNum() {
        console.log('加载数据')
        let that = this

        // 开启loading
        /*         const load = this.$loading({
                   lock: true,
                   text: 'Loading',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
                 }) */

        // var requestUrl = '/form/web/_load_menu_info.jsp'
        // this.axios.get(requestUrl, {
        //     params: {
        //       username: that.username
        //     }
        //   }).then(function(response) {
        //     // load.close()
        //     that.invited_count = response.data.invited_count
        //     that.myform_count = response.data.myform_count
        //   })
        //   .catch(function(error) {
        //     console.log(error)
        //     // load.close()
        //   })
      }
    }
  }
</script>

<style>
  .menuTitleStyle {
    display: flex;
    justify-content: center;
  }

  /* .el-menu-item.is-active {
    background-color: #3370ff !important;
    color: #fff;

    span {
      color: #fff !important;
    }
  } */
</style>



// WEBPACK FOOTER //
// src/components/menu.vue